import React from "react";
import PropTypes from "prop-types";
import Context from "shared/util/Context";
import Str from "shared/components/Str";
import classnames from "classnames";

import "./ProfileQuestionLink.scss";

const ProfileQuestionLink = (props) => {
	const { question, onSkip, isProcessing } = props;
	const qid = question.id;
	const qtext = question.question;
	const username = Context.get("username");

	const _handleSkip = () => {
		if (isProcessing) {
			return;
		}

		onSkip();
	};

	const _handleAnswer = (e) => {
		if (isProcessing) {
			e.stopPropagation();
			e.preventDefault();
		}
	};

	const textClasses = classnames({
		"questionspage-profilelink-text": true,
		isLoading: isProcessing,
	});

	return (
		<div className="questionspage-profilelink">
			<div className={textClasses}>
				{qtext}
			</div>
			<button
				onClick={_handleSkip}
				className="questionspage-profilelink-skip"
			>
				<Str>Skip</Str>
			</button>
			<a
				href={`/profile/${username}/questions?rqid=${qid}&cf=discovery`}
				onClick={_handleAnswer}
				className="questionspage-profilelink-answer flatbutton"
			>
				<Str>Answer</Str>
			</a>
		</div>
	);
};

ProfileQuestionLink.propTypes = {
	question: PropTypes.object.isRequired,
	onSkip: PropTypes.func.isRequired,
	isProcessing: PropTypes.bool,
};

export default ProfileQuestionLink;



// WEBPACK FOOTER //
// ./src/apps/questions/components/ProfileQuestionLink.jsx